/// <amd-module name="VSSUI/Components/ConditionalChildren/ConditionalChildren" />
import * as React from "react";
import { IConditionalChildrenProps } from "./ConditionalChildren.Props";
import { Observer } from "VSSUI/Observer";

export function ConditionalChildren(props: IConditionalChildrenProps & Readonly<{ children?: React.ReactNode }>) {
    return (
        <Observer renderChildren={props.renderChildren}>
            {(observedProps: { renderChildren: boolean | undefined }) => {
                if (observedProps.renderChildren !== !!props.inverse) {
                    if (props.children) {
                        return props.children;
                    }
                }
                return null;
            }}
        </Observer>
    );
}
